"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inbox = void 0;
const MyoCloud_1 = require("./MyoCloud");
const privateDocumentTagPrefix = "Inbox.Private_";
class Inbox {
    constructor(service, idr) {
        this.service = service;
        this.idr = idr;
        this.ready = this.initialize();
    }
    async initialize() {
        const d = await this.service.objectByUniqueTag(await this.service.scramble(privateDocumentTagPrefix + this.idr.id));
        if (!d)
            throw new MyoCloud_1.MyoCloud.Exception("inbox: failed to load box definition object");
        this.definition = d;
        return this;
    }
    get name() { return this.definition.data.name; }
    get id() { return this.idr.id; }
}
exports.Inbox = Inbox;
//# sourceMappingURL=Inbox.js.map